import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import { isAdmin } from '../../../utils/request';

import { salesRep, admin } from './utils/getActions';

const Actions = ({ order, status, fetchOrders }) => {
  const getActions = () => {
    if (isAdmin) return admin;
    return salesRep;
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {_.get(getActions(), status, []).map(Action => (
        <Action status={status} orderData={order} fetchOrders={fetchOrders} />
      ))}
    </div>
  );
};

Actions.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
